import React from 'react';
import {ICRSOutline} from "../interfaces";

interface ICRSOutlineLi {
    crsOutlineLi: ICRSOutline[],
    groupsCount:number
}
/**
 * the entry point
 */
const CRSOutlineLi = (props: ICRSOutlineLi) => {

    const itemArr = props.crsOutlineLi || [];
    const itemFirst = props.crsOutlineLi[0];

        return(
            <ul className="crsoutlineli text-left">
                { props?.groupsCount > 1 &&
                    <li className="first-item flex frex-row py-4 px-6 md:px-10 bg-gray-150 font-bold">
                        <div className="item-counter mr-2">{itemFirst.unitNumber}.</div> <div>{itemFirst.unitName}</div>
                    </li>
                }
                {itemArr && itemArr.map((item, key) =>
                    <li key={key} className="item bg-white">
                        <div className={`item-content flex frex-row py-4 mx-6 md:mx-10 ${itemArr.length !== key + 1 ? "border-b border-b-gray-200" : ""} `}>
                            {
                                props?.groupsCount > 1 &&
                                <div className="item-counter ml-0 md:ml-2 mr-2">{itemFirst.unitNumber}.{item.pageNumber}</div>
                            }
                            {
                                props?.groupsCount === 1 &&
                                <div className="item-counter ml-0 md:ml-2 mr-2">{item.pageNumber}.</div>
                            }
                            { (item.pageUrl === undefined ||  item.pageUrl === null || item.pageUrl === '') &&
                                <div>
                                    {item.pageName}
                                </div>
                            }
                            { (item.pageUrl !== undefined &&  item.pageUrl !== null && item.pageUrl !== '') &&
                                <div>
                                    <a href={item.pageUrl}>{item.pageName}</a>
                                </div>
                            }
                        </div>
                    </li>
                )}
            </ul>
        );

};

export default CRSOutlineLi;